import React from "react";
import { Table, Form, Upload, Select } from "antd";
import { connect } from "react-redux";
import IntlMessages from "@util/IntlMessages";
import { setWidgetInSheetParams } from "appRedux/actions/Actions";
import { sendFile } from "services/restAPI/RestApi";
import layout from "../../GlobalSettings/GlobalSettings";
import { Message, Button, Input } from "../../../../BP2Components";

const { Option } = Select;

const EditableContext = React.createContext();
const EditableRow = ({ form, index, ...props }) => (
   <EditableContext.Provider value={form}>
      <tr {...props} />
   </EditableContext.Provider>
);

const EditableFormRow = Form.create()(EditableRow);

class EditableCell extends React.Component {
   state = {
      editing: false
   };

   toggleEdit = () => {
      const editing = !this.state.editing;
      this.setState({ editing }, () => {
         if (editing) {
            this.input.focus();
         }
      });
   };

   save = (e) => {
      const { record, handleSave } = this.props;
      this.form.validateFields((error, values) => {
         if (error && error[e.currentTarget.id]) {
            return;
         }
         this.toggleEdit();
         handleSave({ ...record, ...values });
      });
   };

   renderCell = (form) => {
      this.form = form;
      const { children, dataIndex, record, title } = this.props;
      const { editing } = this.state;
      return editing ? (
         <Form.Item style={{ margin: 0 }}>
            {form.getFieldDecorator(dataIndex, {
               rules: [
                  {
                     required: true,
                     message: `${title.props.id} is required.`
                  }
               ],
               initialValue: record[dataIndex]
            })(
               <Input
                  // style={{ width: "400px" }}
                  ref={(node) => (this.input = node)}
                  onPressEnter={this.save}
                  onBlur={this.save}
               />
            )}
         </Form.Item>
      ) : (
         <div
            className="editable-cell-value-wrap"
            style={{ paddingRight: 24 }}
            onClick={this.toggleEdit}
         >
            {children}
         </div>
      );
   };

   render() {
      const { editable, dataIndex, title, record, index, handleSave, children, ...restProps } =
         this.props;
      return (
         <td {...restProps}>
            {editable ? (
               <EditableContext.Consumer>{this.renderCell}</EditableContext.Consumer>
            ) : (
               children
            )}
         </td>
      );
   }
}

class IconsWidgetSettings extends React.Component {
   constructor(props) {
      super(props);
      this.columns = [
         {
            title: <IntlMessages id="settings.fileId" />,
            dataIndex: "fileId"
            //editable: true,
         },
         {
            title: <IntlMessages id="settings.fileName" />,
            dataIndex: "fileName",
            editable: true
         },
         {
            title: <IntlMessages id="settings.upload" />,
            dataIndex: "upload",
            // editable: true,
            width: 200
         },
         {
            title: <IntlMessages id="settings.imageTitleTranslationKey" />,
            dataIndex: "imageTitleTranslationKey",
            editable: true
         },
         {
            title: <IntlMessages id="settings.imageSubtitleTranslationKey" />,
            dataIndex: "imageSubtitleTranslationKey",
            editable: true
         },
         {
            title: <IntlMessages id="settings.position" />,
            dataIndex: "imagePosition"
         },
         {
            title: <IntlMessages id="settings.operation" />,
            dataIndex: "operations",
            render: (text, record) =>
               this.state.images.length >= 1 ? (
                  <>
                     <Button
                        buttonType="link"
                        onClick={() => this.handleDelete(record)}
                        className="gx-mt-3"
                     >
                        <IntlMessages id="global.delete" />
                     </Button>
                  </>
               ) : null
         }
      ];
      const rows = [];
      const { value } = this.props;
      value.images.map((image) => {
         rows.push({
            key: value.images.indexOf(image),
            fileId: image.fileId,
            fileName: image.fileName,
            upload: (
               <>
                  <Upload
                     customRequest={this.overwriteDefaultUploadFunction}
                     onChange={this.handleSelectFile.bind(this, value.images.indexOf(image))}
                  >
                     <Button buttonType="primary">Upload</Button>
                  </Upload>
               </>
            ),
            imageTitleTranslationKey: image.imageTitleTranslationKey,
            imageSubtitleTranslationKey: image.imageSubtitleTranslationKey,
            imagePosition: (
               <Select
                  defaultValue={image.imagePosition}
                  style={{ width: 120 }}
                  onChange={this.handleChangeSelectPosition.bind(this, value.images.indexOf(image))}
               >
                  <Option value="LEFT">LEFT</Option>
                  <Option value="RIGHT">RIGHT</Option>
                  <Option value="TOP">TOP</Option>
                  <Option value="BOTTOM">BOTTOM</Option>
               </Select>
            )
         });
         return null;
      });

      this.state = {
         name: value.name,
         id: value.id,
         images: rows,
         webKey: value.webKey,
         priority: value.priority,
         widgetKey: value.widgetKey,
         count: rows.length,
         imageWidgetTitleTranslationKey: value.imageWidgetTitleTranslationKey,
         ...value
      };
   }

   handleDelete = (record) => {
      const images = [...this.state.images];
      this.setState({
         images: images.filter((item) => item.key !== record.key)
      });
   };

   handleChangeInput = (name) => (value) => {
      this.setState({
         [name]: value
      });
   };

   handleChange = (e) => {
      this.setState({ [e.target.name]: e.target.value });
   };
   handleChangeSelectPosition = (count, value) => {
      const newData = [...this.state.images];
      const index = newData.find((item) => count === item.key);
      index.imagePosition = value;
   };
   overwriteDefaultUploadFunction = ({ file, onSuccess }) => {
      setTimeout(() => {
         onSuccess("ok");
      }, 0);
   };

   handleSelectFile = (count, info) => {
      const newData = [...this.state.images];

      var formData = new FormData();
      if (info.file.status !== "uploading") {
      }
      if (info.file.status === "done") {
         Message.success(`${info.file.name} ${(<IntlMessages id="forms.uploadSucces" />)}`);

         formData.append("multipartFile", info.file.originFileObj);
         const index = newData.find((item) => count === item.key);
         index.fileName = info.file.name;
         sendFile(formData).then((res) => {
            index.fileId = res.data;
            this.forceUpdate();
         });
      } else if (info.file.status === "error") {
         Message.error(`${info.file.name} ${(<IntlMessages id="forms.uploadFailed" />)}`);
      }
   };
   handleAdd = () => {
      const { count, images } = this.state;

      const newData = {
         key: count,
         id: Math.floor(Math.random() * 100000) + 1,
         fileId: "1",
         upload: (
            <>
               <Upload
                  customRequest={this.overwriteDefaultUploadFunction}
                  onChange={this.handleSelectFile.bind(this, count)}
               >
                  <Button buttonType="primary">
                     <IntlMessages id="settings.upload" />
                  </Button>
               </Upload>
            </>
         ),
         fileName: "add file",
         imageTitleTranslationKey: "change translation key",
         imageSubtitleTranslationKey: "change translation key",
         imagePosition: (
            <Select
               defaultValue="LEFT"
               style={{ width: 120 }}
               onChange={this.handleChangeSelectPosition.bind(this, count)}
            >
               <Option value="LEFT">LEFT</Option>
               <Option value="RIGHT">RIGHT</Option>
               <Option value="TOP">TOP</Option>
               <Option value="BOTTOM">BOTTOM</Option>
            </Select>
         )
      };
      this.setState({
         images: [...images, newData],
         count: count + 1
      });
   };

   handleSave = (row) => {
      const newData = [...this.state.images];
      const index = newData.findIndex((item) => row.key === item.key);
      const item = newData[index];
      newData.splice(index, 1, {
         ...item,
         ...row
      });
      this.setState({ images: newData });
   };
   handleSubmit = (e) => {
      e.preventDefault();
      this.props.setWidgetInSheetParams(this.state);
      //  this.props.editBackgroundSheet(this.state.backgroundColourHex);
   };
   confirmSave = () => {
      Message.success(<IntlMessages id="save.modal" />);
   };

   render() {
      const { images } = this.state;
      const { value } = this.props;
      const components = {
         body: {
            row: EditableFormRow,
            cell: EditableCell
         }
      };
      const columns = this.columns.map((col) => {
         if (!col.editable) {
            return col;
         }
         return {
            ...col,
            onCell: (record) => ({
               record,
               editable: col.editable,
               dataIndex: col.dataIndex,
               title: col.title,
               handleSave: this.handleSave
            })
         };
      });
      return (
         <div>
            <div className="padding-left-15">
               <Button onClick={this.handleAdd} buttonType="primary">
                  <IntlMessages id="settings.addNewImage" />
               </Button>
            </div>
            <Table
               components={components}
               rowClassName={() => "editable-row"}
               bordered
               dataSource={images}
               columns={columns}
               pagination={false}
            />
            <Form {...layout} className="gx-mt-2 gx-ml-3" onSubmit={this.handleSubmit}>
               <div>
                  <div>
                     <Form.Item
                        key="imageWidgetTitleTranslationKey"
                        label={<IntlMessages id="settings.imageWidgetTitleTranslationKey" />}
                     >
                        <Input
                           type="imageWidgetTitleTranslationKey"
                           name="imageWidgetTitleTranslationKey"
                           defaultValue={value.imageWidgetTitleTranslationKey}
                           onChange={this.handleChange}
                           //  style={{ width: "600px" }}
                        />
                     </Form.Item>
                     <Form.Item key="widgetKey" label={<IntlMessages id="settings.widgetKey" />}>
                        <Input
                           type="widgetKey"
                           name="widgetKey"
                           onChange={this.handleChange}
                           defaultValue={value.widgetKey}
                        />
                     </Form.Item>
                     <Form.Item key="webKey" label={<IntlMessages id="settings.webKey" />}>
                        <Input
                           type="webKey"
                           name="webKey"
                           onChange={this.handleChange}
                           defaultValue={value.webKey}
                        />
                     </Form.Item>
                  </div>
                     <Form.Item>
                        <Button
                           key="btn"
                           buttonType="primary"
                           htmlType="submit"
                           onClick={this.confirmSave}
                        >
                           <IntlMessages id="global.save" />
                        </Button>
                     </Form.Item>
               </div>
            </Form>
         </div>
      );
   }
}

export default connect(null, { setWidgetInSheetParams })(IconsWidgetSettings);
